module.exports = "data:text/x-markdown;base64,Q2xhaW0gb3duZXJzaGlwIG9mIHRoZSBjb250cmFjdCBiZWxvdyB0byBjb21wbGV0ZSB0aGlzIGxldmVsLgoKJm5ic3A7ClRoaW5ncyB0aGF0IG1pZ2h0IGhlbHAKKiBTb2xpZGl0eSBSZW1peCBJREUK"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/fallout.md
// module id = 1375
// module chunks = 0